(() => {
  const storageKey = 'scanmatrix-recently-viewed-products';
  const maxStoredProducts = 10;

  const readStoredProducts = () => {
    try {
      const products = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  };

  const saveStoredProducts = (products) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(products.slice(0, maxStoredProducts)));
    } catch (error) {
      // Recently viewed products are optional when storage is unavailable.
    }
  };

  const createCard = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  };

  const initializeSection = (section) => {
    if (section.dataset.recentlyViewedInitialized === 'true') return;
    section.dataset.recentlyViewedInitialized = 'true';

    const list = section.querySelector('[data-recently-viewed-list]');
    const currentCardTemplate = section.querySelector('[data-current-product-card]');
    const currentProductId = section.dataset.currentProductId;
    const productsToShow = Number.parseInt(section.dataset.productsToShow, 10) || 4;

    if (!list) return;

    const storedProducts = readStoredProducts();
    const fallbackCards = Array.from(list.children);
    const visibleCards = [];
    const usedProductIds = new Set(
      (section.dataset.excludedProductIds || '')
        .split(',')
        .map((productId) => productId.trim())
        .filter(Boolean)
    );

    if (currentProductId) usedProductIds.add(currentProductId);

    storedProducts.forEach((storedProduct) => {
      const productId = String(storedProduct.id);
      if (!storedProduct.html || usedProductIds.has(productId) || visibleCards.length >= productsToShow) return;

      const card = createCard(storedProduct.html);
      if (!card) return;

      card.dataset.productId = productId;
      visibleCards.push(card);
      usedProductIds.add(productId);
    });

    fallbackCards.forEach((card) => {
      const productId = String(card.dataset.productId || '');
      if (!productId || usedProductIds.has(productId) || visibleCards.length >= productsToShow) return;

      visibleCards.push(card);
      usedProductIds.add(productId);
    });

    list.replaceChildren(...visibleCards);
    section.querySelector('.related-products__heading')?.classList.toggle('hidden', visibleCards.length === 0);
    list.classList.toggle('hidden', visibleCards.length === 0);

    const currentCard = currentCardTemplate?.content.firstElementChild;
    if (!currentCard || !currentProductId) return;

    const updatedProducts = [
      {
        id: currentProductId,
        html: currentCard.outerHTML,
      },
      ...storedProducts.filter((storedProduct) => String(storedProduct.id) !== currentProductId),
    ];

    saveStoredProducts(updatedProducts);
  };

  const initializeAllSections = (scope = document) => {
    scope.querySelectorAll('[data-recently-viewed-products]').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllSections());
  } else {
    initializeAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllSections(event.target));
})();
